import { useNavigate } from 'react-router-dom';
import useDatasetStore from '../../../../../store/datasetStore';
import useSearchStore from '../../../../../store/searchStore';

export function useSelectedDataset() {
  const setSearchId = useSearchStore((state) => state.setSearchId);
  const searchId = useSearchStore((state) => state.searchId);
  const selectDataset = useSearchStore((state) => state.selectedDataset);
  const setSelectDataset = useSearchStore((state) => state.setSelectedDataset);
  const setSelectedSearchId = useSearchStore((state) => state.setSelectedSearchId);
  const selectedSearchId = useSearchStore((state) => state.selectedSearchId);

  const datasetBriefs = useDatasetStore((state) => state.datasetBriefs);

  const navigate = useNavigate();

  const onChange = (id: string) => {
    const selectItem = datasetBriefs.find((d) => d.id === id);
    if (!selectItem) return;

    setSearchId(id);
    setSelectDataset({ ...selectItem });
    setSelectedSearchId(id);
    navigate(`/metadata/${selectItem.id}`);
  };

  return {
    selectDataset,
    onChange,
    datasetBriefs,
    searchId,
    selectedSearchId,
  };
}
